import * as types from 'store/actions/types';
import produce from 'immer';

const INITIAL_STATE = {
	isSuccess: false,
	isLoaded: false,
	isPurchaseError: false,
	isPurchaseLoading: false, //added to easier maintain button disabling
	purchaseErrorMessage: '',
	options: undefined,
	paymentMethod: undefined
};

export default (state = INITIAL_STATE, action) =>
	produce(state, (draft) => {
		switch (action.type) {
			// ******************* Submit purchase *******************
			case types.PURCHASE_LOADING:
				draft.isSuccess = false;
				draft.isLoaded = false;
				draft.isPurchaseError = false;
				draft.isPurchaseLoading = true;
				return;

			case types.PURCHASE_SUCCESS:
				draft.options = action.payload.data;
				draft.paymentMethod = action.payload.paymentMethod;
				draft.isSuccess = true;
				draft.isLoaded = true;
				draft.isPurchaseLoading = false;
				return;

			case types.PURCHASE_ERROR:
				draft.isPurchaseError = true;
				draft.isLoaded = true;
				draft.purchaseErrorMessage = action.payload.response.data.message;
				draft.isPurchaseLoading = false;
				return;

			// ******************* Clear purchase *******************
			case types.PURCHASE_CLEAR:
				return INITIAL_STATE;

			default:
				return state;
		}
	});
